import { createSlice } from "@reduxjs/toolkit";

import { contactsAdapter } from "./ContactsAdapter";

// use the contactsAdapter.getInitialState() to get the initial state type
export type ContactsState = ReturnType<typeof contactsAdapter.getInitialState>;

const ContactsStateSlice = createSlice({
    name: "Contacts",
    initialState: contactsAdapter.getInitialState(),
    reducers: {
        setContact: contactsAdapter.upsertOne,
        clearContacts: contactsAdapter.removeAll,
        upsertContacts: contactsAdapter.upsertMany,
        clearContact: contactsAdapter.removeOne,
        clearManyContacts: contactsAdapter.removeMany,
    },
});

export const { clearContacts } = ContactsStateSlice.actions;
export const {
    setContact: setContactAction,
    upsertContacts: upsertContactsAction,
    clearManyContacts,
} = ContactsStateSlice.actions;

export default ContactsStateSlice.reducer;
